import { memo, useEffect, useRef } from 'react';
import { trpc } from 'root/src/client/v2/trpc/trpc';
import { NotificationState, NotificationType } from 'root/src/shared/notification/notification.types';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
import { useRedesignModal } from 'root/src/client/v2/common/contexts/redesignModal.context';
import { NotificationModalContent } from 'root/src/client/v2/notifications/redesign/NotificationModal';
// Redesign of the legacy forced popup (src/client/v2/notifications/components/Notifications.tsx).
// Same behaviour - unread popup notifications are surfaced one at a time and marked read as the
// user advances - but rendered through the v2 redesign modal context (non-closeable card with
// framer enter/exit) instead of the legacy `modal.show`. Mounted on redesign routes in _app
// (the legacy component stays for non-redesign routes, A/B).
export const RedesignNotifications = memo(() => {
    const { authentication } = useAuthentication();
    const redesignModal = useRedesignModal();
    // Ids already surfaced this session, so the bell's 60s poll on the same query does not
    // re-pop the forced modal (or reset the user's place) when it refetches still-unread items.
    const presentedRef = useRef(new Set());
    const notificationsQuery = trpc.notification.list.useQuery({ state: NotificationState.Unread, type: NotificationType.Popup }, { enabled: Boolean(authentication) });
    const notifications = notificationsQuery.data;
    useEffect(() => {
        if (!(notifications === null || notifications === void 0 ? void 0 : notifications.length)) {
            return;
        }
        const fresh = notifications.filter(item => !presentedRef.current.has(item.id));
        if (!fresh.length) {
            return;
        }
        fresh.forEach(item => presentedRef.current.add(item.id));
        redesignModal.show(<NotificationModalContent notifications={fresh}/>, { closeable: false });
    }, [notifications, redesignModal]);
    return null;
});
RedesignNotifications.displayName = 'RedesignNotifications';
